module.exports = __webpack_public_path__ + "img/zone3.e8f2cb22.png";